module.exports = window.location;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/location.js